import { format, isSameDay } from "date-fns";
import { useTranslation } from "react-i18next";

const Header = ({ weekDays = [] }) => {
    const { t } = useTranslation("common");
    const days = [t("monday"), t("tuesday"), t("wednesday"), t("thursday"), t("friday"), t("saturday"), t("sunday")];

    return (
        <div className="calendar-weekly-table__header">
            <div className="calendar-weekly-table__main-time-header"></div>
            {weekDays.map((day, index) => {
                const dayName = days[index];
                const formattedDate = format(day, "yyyy-MM-dd");
                const dayNumber = format(day, "d");
                const isToday = isSameDay(day, new Date());

                return (
                    <div
                        key={index}
                        className={`calendar-weekly-table__day-header calendar-weekly-table__day-header--${day.toLocaleDateString("en", { weekday: "short" }).toLowerCase()} ${isToday ? "calendar-weekly-table__day-header--active" : ""}`}
                        data-date={formattedDate}
                    >
                        {dayName}<br /><span>{dayNumber}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default Header;